var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBellOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notifications Bell On") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1112-Mid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bell-on",
    transform: "translate(-324.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(324.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_notification_1304326",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.246845,18.8461538 C13.056488,20.47045 11.6754257,21.7307692 10,21.7307692 C8.32457431,21.7307692 6.94351196,20.47045 6.75315504,18.8461538 L1.15482623,18.8461538 C0.622479769,18.8461538 0.192307692,18.4170707 0.192307692,17.8857577 L0.192307692,16.7307692 C0.192307692,15.5636392 1.14032112,14.6153846 2.30849496,14.6153846 C2.41323304,14.6153846 2.5,14.5285643 2.5,14.4224064 L2.5,9.80740362 C2.5,6.51763327 4.63437046,3.65537692 7.69230769,2.669311 L7.69230769,2.30802065 C7.69230769,1.03393165 8.72684569,0 10,0 C11.2751898,0 12.3076923,1.03177077 12.3076923,2.30802065 L12.3076923,2.66935862 C15.3655517,3.65555627 17.5,6.51833177 17.5,9.80740362 L17.5,14.4224064 C17.5,14.5306723 17.5847535,14.6153846 17.691505,14.6153846 C18.8578732,14.6153846 19.8076923,15.5633337 19.8076923,16.7307692 L19.8076923,17.8857577 C19.8076923,18.4146145 19.3757548,18.8461538 18.8451738,18.8461538 L13.246845,18.8461538 Z M12.0805046,18.8461538 L7.91949542,18.8461538 C8.10036323,19.8308146 8.96305015,20.5769231 10,20.5769231 C11.0369498,20.5769231 11.8996368,19.8308146 12.0805046,18.8461538 Z M18.6538462,16.7307692 C18.6538462,16.201095 18.22113,15.7692308 17.691505,15.7692308 C16.9476272,15.7692308 16.3461538,15.1680494 16.3461538,14.4224064 L16.3461538,9.80740362 C16.3461538,6.89477385 14.3676354,4.37681869 11.5870098,3.66136612 L11.1538462,3.5499135 L11.1538462,2.30802065 C11.1538462,1.66920562 10.6381212,1.15384615 10,1.15384615 C9.36394592,1.15384615 8.84615385,1.67133477 8.84615385,2.30802065 L8.84615385,3.54990119 L8.41297023,3.66134246 C5.63223423,4.37671742 3.65384615,6.89408596 3.65384615,9.80740362 L3.65384615,14.4224064 C3.65384615,15.1656573 3.0506435,15.7692308 2.30849496,15.7692308 C1.77763846,15.7692308 1.34615385,16.2008252 1.34615385,16.7307692 L1.34615385,17.6923077 L18.6538462,17.6923077 L18.6538462,16.7307692 Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    fill: "#FC8773",
    cx: 16.6666667,
    cy: 5,
    r: 3.95833333
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellOn);
export default __webpack_public_path__ + "static/media/notification-bell-on.835144ea151f511d2fd863d6463cef81.svg";
export { ForwardRef as ReactComponent };